import type { ReactNode } from 'react';
import { LABEL_CLASS } from '@/contabilidad/constants/ui';

interface FormFieldProps {
  label: string;
  required?: boolean;
  className?: string;
  children: ReactNode;
}

export function FormField({ label, required, className, children }: FormFieldProps) {
  return (
    <div className={className}>
      <label className={LABEL_CLASS}>
        {label}
        {required && ' *'}
      </label>
      {children}
    </div>
  );
}
